import React, { useEffect, useMemo, useState } from "react"
import { useAppDispatch } from "../../../store"
import { setCurrentPage } from "../../../store/auth/authReducer"
import Table from "../../../components/Table/Table"
import LinearProgress from "@mui/material/LinearProgress"
import axios from "axios"
import { Link } from "react-router-dom"
import Button from "@mui/material/Button"
import Box from "@mui/material/Box"
import TextField from "@mui/material/TextField"
import { logOut } from "../../../utils/logOut"
import FormControl from "@mui/material/FormControl"
import InputLabel from "@mui/material/InputLabel"
import Select from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import { useSelector } from "react-redux"
import { Fade, Typography } from "@mui/material"
import SimplifiedTable from "../../../components/Table/SimpleTable"
import TranslatedText, { useTranslation } from "../../../utils/Translate"
import { useSnackbar } from "../../../utils/SnackbarContext"

export default function SettingsUpConversationTemplates() {
    const dispatch = useAppDispatch()
    const [tableData, setTableData] = useState([])
    const [loading, setLoading] = useState(false)
    const [partners, setSPartners] = useState([])
    const [conversationtemplates, setConversationtemplates] = useState([])
    const [startRow, setStartRow] = useState(0)
    const [pageRows, setPageRows] = useState(100)
    const [maxRows, setMaxRows] = useState(pageRows)
    const [totalRows, setTotalRows] = useState(0)
    const [filterParams, setFilterParams] = useState(localStorage.getItem('settingsupconversationtemplate_filter') ? JSON.parse(localStorage.getItem('settingsupconversationtemplate_filter') || '{}') : {
        recordnumberfrom: '',
        recordnumberto: '',
        conversationtemplate: '',
        command: '',
        description: '',
        enabled: ''
    })

    const { showSnackbar } = useSnackbar();


    useEffect(() => {
        dispatch(setCurrentPage(`Setting Up Conversation Templates`))
    }, [dispatch]);

    const commands: any = {
        '': useTranslation('All'),
        'wait': useTranslation('Wait'),
        'play': useTranslation('Pronounce'),
        'record': useTranslation('Recognize voice/keys'),
        'transfer': useTranslation('Transfer'),
        'originate': useTranslation('Init a new conversation template'),
        'bridge': useTranslation('Bridge'),
        'setfield': useTranslation('Set conversation field'),
        'setaiprompt': useTranslation('Set AI prompt'),
        'goto': useTranslation('Go to'),
        'eval': useTranslation('Execute code'),
        'cardpaymenthelper': useTranslation('Finalize the card number'),
        'obtainnecessarydigits': useTranslation('Request the necessary digits to complete the card number'),
        'findnearestoffice': useTranslation('Find nearest office'),
        'analyzefreeinput': useTranslation('Analyzing the clients question'),
        'sms': useTranslation('Send SMS'),
        'preparesynthesizedspeech': useTranslation('Prepare the synth audio'),
        'logiccheck': useTranslation('Actualise the current position in the conversation'),
        'end': useTranslation('End call')
    }
    const enabledcommands: any = { '': useTranslation('All'), '1': useTranslation('Yes'), '0': useTranslation('No') }


    const accesslevel = useSelector(
        (state: any) => state.auth.authData.accesslevel
    )

    function saveFilterData() {
        localStorage.setItem('settingsupconversationtemplate_filter', JSON.stringify(filterParams))
    }

    //Get word group
    async function fetchData(params: object = {}) {
        setLoading(true)
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/command`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: { ...params, startRow, maxRows, calculatetotalcount: true }
            })
            if (response.data !== null) {
                if (typeof (response.data) === 'object') {
                    setTotalRows(+response.data[0].totalcount)
                    setTableData(response.data.slice(1))
                }
                else showSnackbar('ERROR: INVALID SERVER RESPONSE', 'error')
            }

            console.log(response.data);

            setLoading(false)
        } catch (error: any) {
            console.log(error);
            if (error.code === "ERR_BAD_REQUEST") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
            setLoading(false)
        }
    }



    //Get conversationtemplate for Select field
    async function getConversationtemplates(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/conversationtemplate`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            console.log(response.data.filter((el: any) => el.showsetuptopartner == '1'));
            setConversationtemplates(accesslevel != 5 ? response.data.filter((el: any) => el.showsetuptopartner == '1') : response.data)
        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    // //on load - fetch data
    // useEffect(() => {
    //     setTimeout(() => fetchData(filterParams), 0)
    //     getConversationtemplates()
    // }, [])

    useEffect(() => {
        setMaxRows(pageRows)
        setStartRow(0)
    }, [filterParams])

    useEffect(() => {
        setTimeout(() => fetchData(filterParams), 0)
        getConversationtemplates()
    }, [startRow, maxRows])

    //Pagination buttons
    function handleBack() {
        if ((startRow - pageRows) < 0) {
            setStartRow(0)
            setMaxRows(pageRows)

        }
        else {
            setStartRow((prev) => prev - pageRows)
            setMaxRows((prev) => prev - pageRows)
        }
    }

    function handleNext() {

        setStartRow((prev) => prev + pageRows)
        setMaxRows((prev) => prev + pageRows)

    }

    function handleEnd() {

        setStartRow(totalRows % pageRows === 0 ? totalRows - pageRows : totalRows - (totalRows % pageRows))
        setMaxRows(totalRows % pageRows === 0 ? totalRows : totalRows - (totalRows % pageRows) + pageRows)

    }

    function handleStart() {

        setStartRow(0)
        setMaxRows(pageRows)

    }

    const totalPages = Math.ceil(totalRows / pageRows);
    const currentPage = Math.ceil(maxRows / pageRows);

    //exclusion of unnecessary table renderers
    const memoizedTable = useMemo(() => <SimplifiedTable rows={tableData} page={'settingsupconversationtemplate'} />, [tableData]);

    return (
        <Box sx={{ height: '86vh', display: 'flex', flexDirection: 'column', mr: 1 }}>
            <Box sx={{ mb: 3, alignItems: "center", display: 'flex', width: "99vw", justifyContent: "space-between" }}>
                    <Link to='/settingsupconversationtemplate' state={{ type: 'add' }}>
                        <Button size="small" sx={{ mr: 7 }} variant="outlined"><TranslatedText text={'Add a new command'} /></Button>
                    </Link>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2, mr: 20, flexWrap: 'wrap' }}>
                    <FormControl>
                        <InputLabel size="small" id="simple-select-label"><TranslatedText text={'Conversation template'} /></InputLabel>
                        <Select sx={{ width: 223 }} labelId="simple-select-label" onChange={(e) => setFilterParams({ ...filterParams, conversationtemplate: e.target.value })} value={filterParams.conversationtemplate} variant="outlined" size="small" label={<TranslatedText text={'Conversation template'} />} >
                            <MenuItem value={''}><TranslatedText text={'All'} /></MenuItem>
                            {
                                conversationtemplates.map((el: any) => (
                                    <MenuItem key={el.id} value={el.id}>{el.conversationtemplatecode}</MenuItem>
                                ))
                            }
                        </Select>
                    </FormControl>
                    <TextField value={filterParams.recordnumberfrom} onChange={(e) => setFilterParams({ ...filterParams, recordnumberfrom: e.target.value })} variant="outlined" size="small" label={<TranslatedText text={'Record number from'} />} />
                    <TextField value={filterParams.recordnumberto} onChange={(e) => setFilterParams({ ...filterParams, recordnumberto: e.target.value })} variant="outlined" size="small" label={<TranslatedText text={'Record number to'} />} />
                    <FormControl>
                        <InputLabel size="small" id="simple-select-label"><TranslatedText text={'Command'} /></InputLabel>
                        <Select renderValue={(selected) => {
                            return commands[selected]
                        }} sx={{ width: 223 }} labelId="simple-select-label" value={filterParams.command} onChange={(e) => setFilterParams({ ...filterParams, command: e.target.value })} variant="outlined" size="small" label={<TranslatedText text={'Command'} />} >
                            <MenuItem value={''}><TranslatedText text={'All'} /></MenuItem>
                            <MenuItem value="wait"><TranslatedText text={'Wait'} /></MenuItem>
                            <MenuItem value="play"><TranslatedText text={'Pronounce'} /></MenuItem>
                            <MenuItem value="record"><TranslatedText text={'Recognize voice/keys'} /></MenuItem>
                            <MenuItem value="transfer"><TranslatedText text={'Transfer'} /></MenuItem>
                            <MenuItem value="originate"><TranslatedText text={'Init a new conversation template'} /></MenuItem>
                            <MenuItem value="bridge"><TranslatedText text={'Bridge'} /></MenuItem>
                            <MenuItem value="setfield"><TranslatedText text={'Set conversation field'} /></MenuItem>
                            <MenuItem value="setaiprompt"><TranslatedText text={'Set AI prompt'} /></MenuItem>
                            <MenuItem value="goto"><TranslatedText text={'Go to'} /></MenuItem>
                            <MenuItem value="eval"><TranslatedText text={'Execute code'} /></MenuItem>
                            <MenuItem value="cardpaymenthelper"><TranslatedText text={'Finalize the card number'} /></MenuItem>
                            <MenuItem value="obtainnecessarydigits"><TranslatedText text={'Request the necessary digits to complete the card number'} /></MenuItem>
                            <MenuItem value="findnearestoffice"><TranslatedText text={'Find nearest office'} /></MenuItem>
                            <MenuItem value="analyzefreeinput"><TranslatedText text={'Analyzing the clients question'} /></MenuItem>
                            <MenuItem value="sms"><TranslatedText text={'Send SMS'} /></MenuItem>
                            <MenuItem value="preparesynthesizedspeech"><TranslatedText text={'Prepare the synth audio'} /></MenuItem>
                            <MenuItem value="logiccheck"><TranslatedText text={'Actualise the current position in the conversation'} /></MenuItem>
                            <MenuItem value="end"><TranslatedText text={'End call'} /></MenuItem>
                            {/* <MenuItem value="closecontact">Управление обзвоном - Закрыть Контакт</MenuItem>
                            <MenuItem value="removefromcampaign">Управление обзвоном - Убрать из Кампании</MenuItem>
                            <MenuItem value="removefromgroup">Управление обзвоном - Убрать из Группы</MenuItem>
                            <MenuItem value="addtogroup">Управление обзвоном - Добавить в Группу</MenuItem>
                            <MenuItem value="plancall">Управление обзвоном - Запланировать Звонок</MenuItem> */}
                        </Select>
                    </FormControl>
                    <TextField value={filterParams.description} onChange={(e) => setFilterParams({ ...filterParams, description: e.target.value })} variant="outlined" size="small" label={<TranslatedText text={'Command description'} />} />
                    <FormControl>
                        <InputLabel size="small" id="simple-select-label"><TranslatedText text={'Command enabled'} /></InputLabel>
                        <Select renderValue={(selected) => {
                            return enabledcommands[selected]
                        }} sx={{ width: 223 }} labelId="simple-select-label" value={filterParams.enabled} onChange={(e) => setFilterParams({ ...filterParams, enabled: e.target.value })} variant="outlined" size="small" label={<TranslatedText text={'Command enabled'} />} >
                            <MenuItem value={''}><TranslatedText text={'All'} /></MenuItem>
                            <MenuItem value="1"><TranslatedText text={'Yes'} /></MenuItem>
                            <MenuItem value="0"><TranslatedText text={'No'} /></MenuItem>
                        </Select>
                    </FormControl>

                    <Button onClick={() => { fetchData(filterParams); saveFilterData() }} size="small" sx={{ mr: 1 }} variant="contained" ><TranslatedText text={'Apply'} /></Button>
                </Box>
                <Box></Box>
            </Box>
            {loading ? <LinearProgress sx={{ width: "50%", marginTop: '33vh', marginLeft: 'auto', marginRight: 'auto' }} /> :
                <>
                    {memoizedTable}
                    <Fade in={!loading} timeout={300}>
                        <Box sx={{ display: 'flex', alignItems: "center", marginTop: 'auto' }}>
                            <Box sx={{ mt: 2 }}>
                                <Button disabled={startRow === 0} onClick={() => handleStart()} size="small" sx={{ mr: 1 }} variant="outlined" >{"<<"}</Button>
                                <Button disabled={startRow === 0} onClick={() => handleBack()} size="small" sx={{ mr: 1 }} variant="outlined" ><span>{'<'}&nbsp;</span> {<TranslatedText text={"Back"} />}</Button>
                                <Button disabled={maxRows >= totalRows} onClick={() => handleNext()} size="small" sx={{ mr: 1 }} variant="outlined" >{<TranslatedText text={'Next'} />}&nbsp;<span>{'>'}</span></Button>
                                <Button disabled={maxRows >= totalRows || tableData.length < pageRows} onClick={() => handleEnd()} size="small" sx={{ mr: 1 }} variant="outlined" >{">>"}</Button>
                            </Box>
                            <Typography sx={{ pt: 2, ml: 2 }}><TranslatedText text={'Rows on page:'} /> {pageRows}</Typography>
                            <Typography sx={{ pt: 2, ml: 2 }}>
                                <TranslatedText text={'Page:'} /> {currentPage} / {totalPages}
                            </Typography>
                            <Typography sx={{ pt: 2, ml: 2 }}><TranslatedText text={'Total rows:'} /> {totalRows}</Typography>
                        </Box>
                    </Fade>
                </>}
        </Box>
    )
}